import { cardSrc } from './resultParsers';

// Lucky 6 (lucky5) — rdesc: "Low Card#Even#Black#2" -> Winner / Odd-Even /
// Color / Card; card = single code (e.g. "2CC")
export default function Lucky6Result({ detail }) {
  const cards = (detail?.card || '').split(',').map((c) => c.trim()).filter(Boolean);
  const parts = String(detail?.rdesc || '').split('#');
  const winner = detail?.winnat || parts[0] || '';
  const oddEven = parts[1] || '';
  const color = parts[2] || '';
  const cardNo = parts[3] || '';

  return (
    <div className="row row5 align-items-center">
      <div className="col-12 col-lg-7">
        <div className="casino-result-content">
          <div className="casino-result-content-item text-center" style={{ alignItems: 'flex-end' }}>
            <div className="casino-result-cards">
              {cards.map((code, i) => (
                <div key={i} className="casino-result-cards-item">
                  <img src={cardSrc(code)} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {' '}
      <div className="col-12 col-lg-5">
        <div className="casino-result-desc">
          <div className="casino-result-desc-item">
            <div>Winner</div>
            {' '}
            <div>{winner}</div>
          </div>
          {' '}
          <div className="casino-result-desc-item">
            <div>Odd/Even</div>
            {' '}
            <div>{oddEven}</div>
          </div>
          {' '}
          <div className="casino-result-desc-item">
            <div>Color</div>
            {' '}
            <div>{color}</div>
          </div>
          {' '}
          <div className="casino-result-desc-item">
            <div>Card</div>
            {' '}
            <div>{cardNo}</div>
          </div>
          {' '}
        </div>
      </div>
    </div>
  );
}
